// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_home_home_module_ts":"3a1214bca8243f39","common":"d82fb7228d1d7523","src_app_features_user-home_user-home_module_ts":"a38d8be8beab2857","src_app_features_manage-profile_manage-profile_module_ts":"ad7a137148e37fc0"}[chunkId] + ".js";
};